// src/components/UpdateUserData.jsx
import React, { useState, useEffect } from 'react';
import { useUser } from '../context/UserContext'; // Import the user context
import api from '../utils/api';
import { useAuth } from '../context/AuthContext'; // Import useAuth for token

const UpdateUserData = () => {
  const { userId, loading, userData } = useUser(); // Access userId and userData from context
  const { token } = useAuth(); // Access token from Auth context
  const [formData, setFormData] = useState({
    fullName: '',
    email: '', // Email will be shown but not editable
    password: '', // Placeholder for password
  });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (userData) {
      // Populate fields with user data if available
      setFormData({
        fullName: userData.fullName || '',
        email: userData.email || '', // Prepopulate email but keep it non-editable
        password: '', // Keep password empty for security
      });
    }
  }, [userData]);

  if (loading) {
    return <p>Loading user data...</p>; // Display loading state
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!userId) {
      setError('User not found');
      return;
    }

    try {
      // Prepare data to send, excluding email
      const { email, ...dataToUpdate } = formData;

      const response = await api.put(`/users/${userId}`, dataToUpdate, {
        headers: {
          Authorization: `Bearer ${token}`, // Include token in the request header
        },
      }); // Send only fullName and password
      setMessage('User updated successfully!');
      setFormData({
        fullName: '', // Reset after successful update
        email: userData.email, // Keep email unchanged
        password: '', // Reset password field
      });
    } catch (err) {
      setError(err.response ? err.response.data.error : 'An error occurred while updating user data.');
    }
  };

  return (
    <div>
      <h2>Update User Data</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>
            Full Name:
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </label>
        </div>
        <div>
          <label>
            Email:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              readOnly // Make email field read-only
            />
          </label>
        </div>
        <div>
          <label>
            Password:
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your new password" // Placeholder for password field
            />
          </label>
        </div>
        <button type="submit">Update User</button>
      </form>
      {message && <p style={{ color: 'green' }}>{message}</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
};

export default UpdateUserData;
